/* eslint-disable react/no-unknown-property,no-undef */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import { SidebarGrid, HamBurgerContainer, MainSideBarLinks, Navigation, StyledLink, StyledSvg, SidebarCard } from './style';
import {
  uploadProfile,
  getRewardPoints,
  getCompanyBrandingDetails,
} from "../../redux/actions";
import Loading from "../Loading";
import { withTranslation } from "react-i18next";
import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import Waiting from "../Waiting";
import {
  HamBurgerContainer,
  MainSideBarLinks,
  Navigation,
  SidebarCard,
  SidebarGrid,
  StyledLink,
  StyledSvg,
} from "../SideBarV3/style";
import {
  ManagerFeedIcon,
  ManagerHistoryIcon,
  ManagerRecognitionIcon,
} from "../../utils/icons";

const managerNavigationArray = [
  {
    name: 'Recognition',
    id: 'company-dashboard-nav',
    active: 'dashboard',
    route: '/manager/dashboard',
    // width: '12px',
    // height: '12px',
    svg: ManagerRecognitionIcon,
    value: "recognition"
  },
  {
    name: 'Social Feed',
    id: 'company-dashboard-nav1',
    active: 'social',
    route: '/manager/social-feed',
    // width: '18px',
    // height: '20px',
    svg: ManagerFeedIcon,
    value: "feed",
  },
  {
    name: "History",
    id: "company-dashboard-nav2",
    active: "history",
    route: "/manager/history",
    value: "history",
    svg: ManagerHistoryIcon,
  },
];

class SideBarV4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: "Training Amigo",
      totalPoints: 80,
      showSideBarMenu: false,
      imgSrc: "",
      hide: false,
      colorInfo: this.props.colorInfo2,
      hoverState: null,
      hoverStateAdmin: null,
    };
  }

  componentDidMount() {
    const { fetchCompanyBrandingDetails, userCompany } = this.props;
    if (userCompany.id) {
      fetchCompanyBrandingDetails(userCompany.id);
    }
  }

  componentDidUpdate(prevProps) { 
    const { colorInfo2 } = this.props;  
    if (prevProps.colorInfo2 !== colorInfo2) {
      this.setState({
        colorInfo: colorInfo2,
      });
    }
  }
    

  getSideTabStatus = (route) => {
    let findIndex = managerNavigationArray.findIndex(
      (data) => data.route === route
    );
    return findIndex === -1;
  };

  showSideBarMenuOptions = () => {
    this.setState((prev) => ({
      showSideBarMenu: !prev.showSideBarMenu,
    }));
  };

  renderNavigation = (currentLocation, getColor, hideContent, colorInfo,sideBarIconColor) => (
    <div>
      {this.renderCompanyNavigation(
        currentLocation,
        getColor,
        hideContent,
        colorInfo,
        sideBarIconColor
      )}
    </div>
  );

  changeRoute = (value) => {
    const { history } = this.props;
    this.setState({
      showSideBarMenu: false,
    });
    history.push(value);
  };

  renderCompanyNavigation = (CurrentLocation, getColor, hideContent) => {
    // const { colorInfo, hoverState } = this.state;
    // const { role } = this.props;
    let getRGBAColor;
    if (this.props.brandingColor) {
      getRGBAColor = this.hexToRGBA(this.props.brandingColor, 0.1);
    }
    const sideBarIconColor =  this.applyOpacityToColor(this.props.brandingColor || 'rgb(11, 65, 112)', 0.5)
    return (
      <Navigation   id="navigation">
        {managerNavigationArray.map((navigator, index) => (
          // navigator.condition ?
          <li id={navigator.id} key={index}>
            <StyledLink
              id="side-bar-link"
              commonDashboard
              onClick={() => this.changeRoute(navigator.route)}
              onMouseEnter={() => this.showCardAdmin(navigator.value)}
              onMouseLeave={() => this.hideCardAdmin()}
              active={CurrentLocation.includes(navigator.active) ? 1 : 0}
              // bgColor={"rgba(0, 171, 182, 1)"}
              bgColor={getRGBAColor}
              colour={getColor ? getColor : "#0b4170"}
              hideContent={hideContent ? 1 : 0}
              width={"0px"}
              bottom={"0px"}
              left={"100px"}
              color={getColor ? getColor : "#0D4270"}
            >
              <span className="iconLinkContainer">
               
                <StyledSvg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  {navigator.svg(sideBarIconColor)}
                </StyledSvg>
                {hideContent ? null : <span>{navigator.name}</span>}
              </span>
              {hideContent && this.state.hoverStateAdmin === navigator.value ? (
                <SidebarCard
                  id="side-bar-card"
                  width="0px"
                  bottom="0px"
                  left="100px"
                  commonDashboard
                  colour={getColor ? getColor : "#00ABB6"}
                >
                  <div id="arrow" className="arrow">...</div>
                  <div id="name" className="name">{this.props.t(navigator.name)}</div>
                </SidebarCard>
              ) : null}
              <div dashboard={1} />
            </StyledLink>
          </li>
        ))}
      </Navigation>
    );
  };

  hexToRGBA = (hex, alpha) => {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
    }
  };

  showCard = (value) => {
    this.setState({
      hoverState: value,
    });
  };

  showCardAdmin = (value) => {
    this.setState({
      hoverStateAdmin: value,
    });
  };

  hideCard = () => {
    this.setState({
      hoverState: null,
    });
  };

  hideCardAdmin = () => {
    this.setState({
      hoverStateAdmin: null,
    });
  };

  applyOpacityToColor(color, opacity) {
    if (!color) return `rgba(11, 65, 112, ${opacity})`;
  
    if (color.startsWith('#')) {
      // Convert hex to RGB
      const hex = color.replace('#', '');
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
  
    if (color.startsWith('rgb(')) {
      return color.replace('rgb(', 'rgba(').replace(')', `, ${opacity})`);
    }
  
    return color; // fallback to original if unknown format
  }

  render() {
    const {
      response,
      networkError,
      pathValue,
      reward,
      hideContent,
      colorInfo2,
    } = this.props;
    if ((!response || !reward) && !networkError) {
      return <Loading />;
    }
    if (isUndefined(colorInfo2) || isNull(colorInfo2)) {
      return <Waiting />;
    }
    const { showSideBarMenu,colorInfo } = this.state;
    const CurrentLocation = pathValue;
    const Visibility = hideContent;
    // const trainingCompleted = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    // let navIndex =  -1;
    // let getColor = navIndex !== -1 && '';

    const navIndex =colorInfo && colorInfo.color_branding &&
    colorInfo?.color_branding?.length > 0
      ? colorInfo?.color_branding?.findIndex(
        (data) => data?.custom_name === "side_menu_color"
      )
      : -1;

    const getColor =
      navIndex !== -1 && colorInfo?.color_branding[navIndex]?.color_code;


    return (
      <SidebarGrid
        id="side-bar"
        manager
        color={getColor || "rgb(11, 65, 112)"}
        style={{ backgroundColor: "white" }}
        hideContent={hideContent ? 1 : 0}
      >
        <HamBurgerContainer
          id="hamburger-container"
          onClick={this.showSideBarMenuOptions}
          showCompany={CurrentLocation.includes("manager")}
        >
          <i className="fa fa-bars" />
        </HamBurgerContainer>
        <MainSideBarLinks smallDevices>
          {showSideBarMenu &&
            this.renderNavigation(
              CurrentLocation,
              this.props.brandingColor,
              Visibility,
              colorInfo2
            )}
        </MainSideBarLinks>
        <MainSideBarLinks>
          {this.renderNavigation(
            CurrentLocation,
            this.props.brandingColor,
            Visibility,
            colorInfo2
          )}
        </MainSideBarLinks>
      </SidebarGrid>
    );
  }
}

SideBarV4.propTypes = {
  history: PropTypes.object.isRequired,
  response: PropTypes.object,
  networkError: PropTypes.string,
  uploadProfile: PropTypes.func.isRequired,
  pathValue: PropTypes.string.isRequired,
  fetchRewardPoints: PropTypes.func.isRequired,
  reward: PropTypes.object,
  showReportTab: PropTypes.bool,
  role: PropTypes.string,
  userPermissions: PropTypes.array,
  colorData: PropTypes.object,
  hideContent: PropTypes.bool,
  hideTab: PropTypes.object,
  colorInformation: PropTypes.object,
  fetchCompanyBrandingDetails: PropTypes.func.isRequired,
  currentCompanyId: PropTypes.number,
  colorInfo2: PropTypes.object,
  t: PropTypes.func,
  billingTabStatus: PropTypes.number,
  userCompany: PropTypes.object,
  brandingColor:PropTypes.string
};

const mapStateToProps = (state) => ({
  reward: state.wellnessDashboard.reward,
  showReportTab: state.companyDashboard.showReportTab,
  colorInfo2: state.wellnessDashboard.companyBrandingDetails,
  billingTabStatus: state.stripeData.billingTabStatus,
  hideTab: state.wellnessDashboard.companyBrandingDetails,
  userCompany: state.profileData.userCompany,
  brandingColor:state.wellnessDashboard.brandingColor
});

const mapDispatchToProps = (dispatch) => ({
  uploadProfile: (profile) => dispatch(uploadProfile(profile)),
  fetchRewardPoints: () => dispatch(getRewardPoints()),
  fetchCompanyBrandingDetails: (id) => dispatch(getCompanyBrandingDetails(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(SideBarV4));
